module.exports = __webpack_public_path__ + "guiding-principles-2.svg?700778b12db701c33adc4343ee2eabac";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/guiding-principles-2.svg
// module id = 46
// module chunks = 0